import React from 'react';
import PropTypes from 'prop-types';

import { Stage } from '@ccg/ligalux';

import Embeds from '../../shared/Embeds/Embeds';
import PageTemplate from '../templates/page';

import { withTranslation } from '../../../i18n';

const JobTemplate = ({ data, t }) => {
  if (!data.entry) return null;

  const { cookieLayer, entry, footer, seoDefaults, navigation, social } = data;
  const { jobsOverviewPage } = navigation;

  const { contentType, title, subline, embeds, embedsCopy, locations } = entry;

  return (
    <PageTemplate
      seo={entry}
      seoDefaults={seoDefaults}
      navigation={navigation}
      footer={footer}
      social={social}
      cookieLayer={cookieLayer}
    >
      <Stage
        variant={contentType === 'advertising' ? 'default' : 'standard'}
        headline={title}
        title={title}
        subline={subline}
        newsFormat={
          locations &&
          locations.length > 0 &&
          locations.map((item, i) => (i !== 0 ? `, ${item.title}` : item.title))
        }
        breadcrumbLink={
          jobsOverviewPage && jobsOverviewPage[0]
            ? {
                label: t('navigation.back'),
                href: {
                  pathname: '/standard',
                  query: { uri: jobsOverviewPage[0].uri }
                },
                asPath: `/${jobsOverviewPage[0].uri}`
              }
            : undefined
        }
      />

      <Embeds embedsCopy={embedsCopy} embeds={embeds} />
    </PageTemplate>
  );
};

JobTemplate.propTypes = {
  data: PropTypes.shape().isRequired,
  t: PropTypes.func.isRequired
};

JobTemplate.defaultProps = {};

export default withTranslation('common')(JobTemplate);
